import * as React from "react";
import { cx, css } from "@emotion/css";

interface SelectableButtonProps {
  onClick: (e: React.SyntheticEvent) => void;
  text: string;
  id: string;
}

export const SelectableButton = ({
  onClick,
  text,
  id
}: SelectableButtonProps) => {
  const selectableButton = css`
    width: 150px;
    height: 60px;
    background-color: white;

    border: 0;
    padding: 12px;
    text-shadow: none;
    font-size: 1em;
    line-height: 1em;
    border-radius: 3px;
    font-size: 0.85em;
    color: #007eb7;
    &:hover {
      color: #000;
    }
  `;

  const buttonBorderClass = css`
    border: 1px solid #007eb7;
    border-radius: 3px;
  `;

  const notSelectableClass = css`
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  `;

  return (
    <button
      className={cx(selectableButton, notSelectableClass, buttonBorderClass)}
      type="button"
      onClick={onClick}
      id={id}
    >
      {text}
    </button>
  );
};
